import React, { useState, useEffect } from 'react'
import {
  withStyles,
  MenuItem,
  FormControl,
  Select,
  Divider,
  Typography,
  FormControlLabel,
} from '@material-ui/core'
import styles from './styles'
import { useSelector, useDispatch } from 'react-redux'
import CustomizedSwitch from 'src/components/customized-switch'
import { CoreButton, CoreTextField } from 'src/components/core'
import { Icon } from '@iconify/react'
import translator from 'src/translate'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { domainListAction } from 'src/reducers/domain/action'
import { useHistory } from 'react-router-dom'
const ShareLinkCourse = props => {
  const { classes, handleView } = props
  const dispatch = useDispatch()
  const course = useSelector(state => state.course.course)
  const [copiedShareCode, setCopiedShareCode] = useState(false)
  const [showShareButtons, setShowShareButtons] = useState(0)
  const [domains, setDomains] = useState()
  const history = useHistory()
  useEffect(() => {
    const query = {
      CurrentPage: 0,
      PageSize: 5,
      SortingColumn: 'LastModifiedAt',
      Asc: false,
      FilterText: '',
      Filters: [],
    }

    dispatch(
      domainListAction({ ...query, SortingColumn: 'LastModifiedAt' }, data => {
        setDomains(data.results)
        data.results.filter(x => x.verificationStatus == 1)[0].domain
          ? setDomainName(
              data.results.filter(x => x.verificationStatus == 1)[0].domain,
            )
          : setDomainName('share.minicoursegenerator.com')
      }),
    )
  }, [])

  const onClickShareCode = () => {
    setCopiedShareCode(true)
    setTimeout(() => {
      setCopiedShareCode(false)
    }, 1000)
  }

  const customDomain = useSelector(state => state.domain.list)

  const customDomainList = customDomain && customDomain.results
  const collectionDomain =
    customDomainList &&
    customDomainList.filter(
      item =>
        item.defaultCollectionDto != null &&
        item.defaultCollectionDto.id == course.id &&
        item.verificationStatus == 1,
    )
  const domain =
    collectionDomain?.length > 0
      ? collectionDomain[0].domain
      : 'share.minicoursegenerator.com'

  const [domainName, setDomainName] = useState(domain)

  const handleDomain = e => {
    setDomainName(e.target.value)
  }
  let shareCode = showShareButtons ? '?shr=1' : ''

  const data = [
    {
      title: 'Embed on a Website',
      icon: 'iconoir:code',
      color: '#FB9D01',
      onClick: () => handleView('embed-course'),
    },
    {
      title: 'iFrame Code',
      icon: 'ph:devices',
      color: '#29D25D',
      onClick: () => handleView('iframe-course'),
    },
    {
      title: 'Download as PDF',
      icon: 'hugeicons:pdf-01',
      color: '#ED4245',
      onClick: () => handleView('pdf-course'),
    },
    {
      title: 'Download as SCORM',
      icon: 'ph:cube',
      color: '#5DADFF',
      onClick: () => handleView('scorm-course'),
    },
  ]

  return (
    <div className={classes.shareViewRoot}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <Typography fontSize={'14px'} fontWeight={400} fontFamily={'Inter'}>
          Choose your domain
        </Typography>
        <FormControl
          variant="outlined"
          className={classes.shareViewFormControl}
        >
          <Select
            labelId="domain-selection-label"
            id="domain-selection-select"
            fullWidth
            value={domainName}
            disabled={false}
            onChange={handleDomain}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    marginLeft: '8px',
                    marginRight: '8px',
                    borderRadius: '8px',
                    marginTop: '4px',
                    marginBottom: '4px',
                  },
                },
              },
            }}
          >
            <MenuItem value={'share.minicoursegenerator.com'}>
              (Default) share.minicoursegenerator.com
            </MenuItem>

            {domains &&
              domains
                .filter(x => x.verificationStatus == 1)
                .map(value => {
                  return (
                    <MenuItem value={value.domain} key={value.domain}>
                      {value.domain}
                    </MenuItem>
                  )
                })}
          </Select>
        </FormControl>

        <Typography
          fontSize="12px"
          fontWeight={400}
          color="#015FFB"
          onClick={() => {
            history.push('/custom-domain')
          }}
          style={{
            cursor: 'pointer',
          }}
        >
          Want to customize the domain of the links?
        </Typography>
      </div>

      <CoreTextField
        fullWidth
        value={'https://' + domainName + `/${course.code}` + shareCode}
        label="Mini-course link"
      />
      <div className={classes.settingsShare}>
        <FormControlLabel
          style={{
            margin: 0,
          }}
          control={
            <CustomizedSwitch
              checked={showShareButtons}
              onChange={(e, checked) => {
                setShowShareButtons(checked)
              }}
              name="checkedB"
            />
          }
          label={translator._('assignment.showShareButtonsLabel')}
        />
      </div>
      <CopyToClipboard
        text={'https://' + domainName + `/${course.code}` + shareCode}
      >
        <CoreButton
          onClick={onClickShareCode}
          variant="contained"
          color="primary"
          fullWidth
        >
          {copiedShareCode ? 'Copied!' : 'Copy Link'}
        </CoreButton>
      </CopyToClipboard>

      <Divider className={classes.shareViewDivider} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        {data.map((item, index) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              justifyContent: 'center',
              width: '80px',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={item.onClick}
          >
            <div className={classes.iconDiv}>
              <Icon icon={item.icon} color={item.color} fontSize={24} />
            </div>
            <Typography
              fontSize={'14px'}
              fontWeight={400}
              fontFamily={'Inter'}
              textAlign={'center'}
            >
              {item.title}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  )
}

export default withStyles(styles)(ShareLinkCourse)
